// hero bottom slider
(function () {
  const heroBottomSlider = document.querySelector('.hero_banner__bottom_content.swiper');
  if (heroBottomSlider) {
    const slidesCount = Number(heroBottomSlider.dataset.slidesCount || 0);
    if (slidesCount > 1) {
      var init = false;
      var swiper;
      function hero_bottom_slider() {
        if (window.innerWidth <= 768) {
          if (!init) {
            init = true;
            swiper = new Swiper(".hero_banner__bottom_content.swiper", {
              direction: "horizontal",
              slidesPerView: 1,
              spaceBetween: 32,
              pagination: {
                el: ".hero_banner__bottom_content .swiper-pagination",
                clickable: true,
              },
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      hero_bottom_slider();
      window.addEventListener("resize", hero_bottom_slider);
    }
  }
})();
// hero bottom slider
